/*
 * @Author: yanghailong
 * @Date: 2023-01-12 16:44:08
 * @Last Modified by: yanghailong
 * @Last Modified time: 2024-07-26 17:13:37
 */
import './global.js'
import '@/components-web'
import { createApp } from 'vue'


import ElementPlus from 'element-plus'
// 样式
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import 'eui/eui.css'
import './css/variable.css'
import './css/style.css'
import './css/supervisor.css'
import  '~/thirdPart/font-awesome-4.7.0/css/font-awesome.css'
import "jd-specific/useElementUI"
import SPC from "jd-specific"
import App from './App.vue'
import router from './router'
import Eui from 'eui/vue-components'
import locale from 'element-plus/es/locale/lang/zh-cn'
// svg图标
import SvgIcon from './common/svg-icon.vue'
import 'virtual:svg-icons-register'
// 一定要在main.ts中导入tailwind.css，防止vite每次hmr都会请求src/style/index.scss整体css文件导致热更新慢的问题
import "./css/tailwind.css"

const app = createApp(App)

app.use(SPC);
app.component('svg-icon', SvgIcon)
app.use(Eui)
app.use(ElementPlus,{locale})
app.use(router)
app.mount('#app')

